import type { IconData } from '@stacksjs/iconify-core'

export const caoDai: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M20.185 6.406c-4.15 6.126-10.961 16.896-16.73 29.389c-1.324 2.866.448 6.087 3.588 6.41c3.89.4 9.597.795 16.956.795c7.36 0 13.067-.395 16.956-.795c3.14-.323 4.912-3.544 3.588-6.41c-5.769-12.493-12.58-23.263-16.73-29.389c-1.863-2.75-5.765-2.75-7.628 0\"/><path d=\"M37 27c-2.942-5.46-7.67-9-13-9s-10.058 3.54-13 9c2.942 5.46 7.67 9 13 9s10.058-3.54 13-9\"/><path d=\"M28 27a4 4 0 1 0-8 0a4 4 0 0 0 8 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default caoDai
